import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { Router, ActivatedRoute, Params, Data } from "@angular/router";
import { FormConfigModel } from '@shared/_models/Layout/FormConfig';
import { EmailValidationMessageType, StatusCode } from '@shared/_enums/Common';
import { CommonService } from '@services/app.common.service';
import { ForgotPasswordQueues } from '@shared/_models/jobsAndTalents/jobsAndTalentsModels';
import { User } from '../Interface/force-password-change.interface';

@Component({
    selector: 'app-forgot-password-step1.component',
    templateUrl: './forgotPasswordStep1.component.html',
    standalone: false
})
export class ForgetPasswordUserStep1Component implements OnInit {
  public securityCode: string = '';
  public systemUserId: string = '';
  public gSystemUserId: string = '';
  public StatusCode = StatusCode;
  public userId: any;
  public userGuid: any;
  public modalConfig = {} as FormConfigModel;
  public forgotPasswordQueues = {} as ForgotPasswordQueues;
  public tokenResponse: any;
  public _baseUrl;
  public user = {} as User;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public common: CommonService,
    private renderer: Renderer2,
    @Inject('BASE_URL') baseUrl: string
  ) {

    this.renderer.removeClass(document.body, 'body-class');
    this.renderer.addClass(document.body, 'body-class-login');
    this._baseUrl = baseUrl;


    this.route.queryParams.subscribe((params: Params) => {

      this.user.userPasswordQueueId = params['systemuserid'];
      this.user.userGuid = params['gsystemuserid'];
    });
  }

  ngOnInit() {

    this.route.data.subscribe((data: Data) => {
      this.tokenResponse = data['tokenResponse'];
    });
    this.route.queryParams
      // .filter(params => params.order)
      .subscribe(params => {
        this.systemUserId = params.systemuserid;
        this.gSystemUserId = params.gsystemuserid;
      });
    this.modalConfig.hideDefaultAction = true;
    this.modalConfig.hideCard = false;
    this.emailSecurityCode();
  }
  emailSecurityCode() {
    this.common.SetAccessToken(this.tokenResponse.resultData);
    this.common.Loader.show();
    let $this = this;
    this.common.PostData(this.common.ApiUrls.SystemSettings.EmailSecurityCode, this.user).then(data => {
      $this.common.Loader.hide();
      var result = data;
      if (result.status == this.StatusCode.OK) {
        this.forgotPasswordQueues = result.resultData;
        this.forgotPasswordQueues.securitycode = '';
        this.forgotPasswordQueues.sYSTEMUSERID = this.forgotPasswordQueues.usersPasswordQueueID;
        this.common.Notification.success(this.common.GetTranslation('Messages.EmailSecurityCode'));
      }
      else if (result.status == this.StatusCode.failure && result.resultData == null) {
        this.common.Notification.error(this.common.GetTranslation(result.message));
        setTimeout(() => {
          window.close();
        }, 3000);
      }
      else {
        if (result.message != null) {
          if (result.resultData == EmailValidationMessageType.Error) {
            this.common.Notification.error(this.common.GetTranslation('Messages.ErrorSendingEmail'));

          } else {
            this.forgotPasswordQueues = result.resultData;
            this.forgotPasswordQueues.securitycode = "";
            this.forgotPasswordQueues.sYSTEMUSERID = this.forgotPasswordQueues.usersPasswordQueueID;
            this.common.Notification.info(this.common.GetTranslation('Messages.AlreadySentSecurityCode'));
          }
        }
      }
    });
  }

  SubmitSecurityCode() {
    this.common.SetAccessToken(this.tokenResponse.resultData);
    if (this.forgotPasswordQueues.securitycode != this.securityCode) {
      this.forgotPasswordQueues.securitycode = this.securityCode;

    }
    this.user.id = this.forgotPasswordQueues.usersPasswordQueueID;
    this.user.securityCode = this.forgotPasswordQueues.securitycode;
    this.user.userGuid = this.forgotPasswordQueues.guid;
    this.common.PostData(this.common.ApiUrls.SystemSettings.VerifySecurityCode, this.user).then(data => {
      let result = data;
      if (result.status == this.StatusCode.OK) {
        this.common.SetSessionStorage('forgotPasswordSecurityCode', this.forgotPasswordQueues.securitycode);
        this.common.NavigateToRouteWithQueryString(this.common.ApiUrls.ForgotPassword.UpdatePassword, { queryParams: { systemUserId: this.forgotPasswordQueues.usersPasswordQueueID, gSystemUserId: this.forgotPasswordQueues.guid } });
      } else {
        this.common.RemoveSessionStorage('forgotPasswordSecurityCode');
        this.common.Notification.error(this.common.GetTranslation('Messages.Error'));
      }
    });
  }
}
